// Client-side image compression. Resizes to a max width and re-encodes
// as JPEG (or PNG if alpha) to keep payloads small enough to inline as
// base64 data URLs without third-party storage.
export async function fileToCompressedDataURL(file, opts = {}) {
    const {
        maxWidth = 1600,
        maxHeight = 1600,
        quality = 0.82,
        mime = "image/jpeg",
    } = opts;

    if (!file || !file.type?.startsWith("image/")) {
        throw new Error("El archivo no es una imagen.");
    }

    const dataUrl = await readAsDataURL(file);
    const img = await loadImage(dataUrl);

    let { width, height } = img;
    const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
    width = Math.round(width * ratio);
    height = Math.round(height * ratio);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    // White background to handle transparent PNGs when re-encoding as JPEG
    if (mime === "image/jpeg") {
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, width, height);
    }
    ctx.drawImage(img, 0, 0, width, height);

    return canvas.toDataURL(mime, quality);
}

function readAsDataURL(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

function loadImage(src) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });
}
